import { render, staticRenderFns } from "./EditJourneyAction.vue?vue&type=template&id=5e79c7a9"
import script from "./EditJourneyAction.vue?vue&type=script&lang=js"
export * from "./EditJourneyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports